import { useEffect, useRef } from "react";
import { useParams, Navigate } from "react-router-dom";
import { db, collection, doc, setDoc, serverTimestamp } from "../firebase"; // Firestore import

function QRRedirect() {
  const { musicianId } = useParams();
  const hasSaved = useRef(false); // 중복 저장 방지

  useEffect(() => {
    if (hasSaved.current) return; // 이미 실행된 경우 실행 방지
    hasSaved.current = true; // 실행 여부 체크

    const saveScanData = async () => {
      try {
        // Firestore 경로: hit_manage → qr_scans → musicianId → timestamp 문서
        const scanRef = doc(collection(db, "hit_manage", "qr_scans", musicianId));

        await setDoc(scanRef, {
          timestamp: serverTimestamp(),
          userAgent: navigator.userAgent, // 사용자의 기기 정보
          referrer: document.referrer, // 리퍼러 정보 (어디서 왔는지)
          fullUrl: window.location.href, // 접속한 전체 URL 저장
        }, { merge: true }); // 덮어쓰기 방지

        //console.log("QR 코드 접속 기록 저장 성공!");
      } catch (error) {
        //console.error("QR 코드 접속 기록 저장 실패: ", error);
      }
    };

    saveScanData();
  }, [musicianId]);

  return <Navigate to={`/musicard/${musicianId}`} replace />;
}

export default QRRedirect;